/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const deliveryOrderLines = sqliteTable('delivery_order_lines', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  delivery_order_id: text('delivery_order_id'),
  purchase_order_line_id: text('purchase_order_line_id'),
  inventory_item_id: text('inventory_item_id'),
  inventory_batch_id: text('inventory_batch_id'),
  item_name_snapshot: text('item_name_snapshot'),
  sku_snapshot: text('sku_snapshot'),
  unit_snapshot: text('unit_snapshot'),
  purchasing_unit_ordered: text('purchasing_unit_ordered'),
  quantity_ordered: real('quantity_ordered'),
  quantity_received: real('quantity_received'),
  bonus_quantity_received: real('bonus_quantity_received'),
  unit_price: real('unit_price'),
  unit_price_without_bonus: real('unit_price_without_bonus'),
  rate: real('rate'),
  amount: real('amount'),
  batch_number_snapshot: text('batch_number_snapshot'),
  expiry_date_snapshot: text('expiry_date_snapshot'),
  remarks: text('remarks'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
